import { render, staticRenderFns } from "./OnViewport.vue?vue&type=template&id=2e2b9995&lang=pug"
import script from "./OnViewport.vue?vue&type=script&lang=js"
export * from "./OnViewport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports